import { createContext, useState, useEffect } from "react";
import axios from "axios";
import { projectList } from "../constants/Project";

export const ProjectsContext = createContext();

const formatProjectName = (name) => {
    return name
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const ProjectsProvider = ({ children }) => {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const getProjects = async () => {
            try {
                const response = await axios.get("https://api.github.com/users/Ayush-Kaushik/repos?sort=created");

                const data = response.data.filter(item => {
                    if (projectList.includes(item.id)) {
                        const date = new Date(item.updated_at);
                        item['updated_at'] = "🗓️ Last Updated: " + date.toDateString();
                        item['name'] = formatProjectName(item.name);
                        return item;
                    }

                    return "";
                });

                setProjects(data);
            } catch (error) {
                setHasError(true);
            } finally {
                setIsLoading(false);
            }
        }

        getProjects();
    }, []);

    return (
        <ProjectsContext.Provider value={{
            projects,
            isLoading,
            hasError
        }}>
            {children}
        </ProjectsContext.Provider>
    )
}